import React, { FC } from "react";
import { IonSelectOption } from "@ionic/react";
import { useTranslation } from "react-i18next";
import { RegisterOptions } from "react-hook-form";
import { R6IonSelect } from "./r6ionic/R6IonSelect";
import { POSITION_CONFIGS } from "../types/footballPosition";

interface PositionDropdownProps {
    name: string;
    label?: string;
    labelPlacement?: "stacked" | "floating" | "fixed";
    testId?: string;
    className?: string;
    slot?: string;
    rules?: RegisterOptions;
}

export const PositionDropdown: FC<PositionDropdownProps> = ({
    name,
    label,
    labelPlacement,
    testId,
    className,
    slot,
    rules,
}) => {
    const { t } = useTranslation();

    return (
        <R6IonSelect
            name={name}
            testid={testId || name}
            label={label}
            labelPlacement={labelPlacement}
            interface="popover"
            className={className}
            slot={slot}
            rules={rules}
        >
            {POSITION_CONFIGS.map((config) => (
                <IonSelectOption key={config.code} value={config.code}>
                    {t(`positions.names.${config.code}`)}
                </IonSelectOption>
            ))}
        </R6IonSelect>
    );
};
